/**
 * Various Element manipulation utilities
 */

const cssTo = ($el, config) => {
  if (!$el) {
    return
  }
  $el.addClass(config.to)
  if (config.from !== '') {
    $el.removeClass(config.from)
  }
}
const cssReverse = ($el, config) => {
  if (!$el) {
    return
  }
  $el.addClass(config.from)
  $el.removeClass(config.to)
}

export {
  cssTo,
  cssReverse,
}
